// v2
// Path: frontend/src/components/SyncHub/shared/GlobalDialogs.jsx
// Inputs: None (reads from Zustand store dialogs)
// Outputs: Global alert and confirm headless UI modals with cascading warnings support
// Summary: Centralized global dialog provider replacing native window.alert/confirm with dark theme and warning cues.

import React from 'react';
import ModalShell from './ModalShell';
import { useSyncStore } from '../useSyncStore';

export default function GlobalDialogs() {
    const dialogs = useSyncStore(state => state.dialogs);

    if (!dialogs) return null;

    return (
        <>
            {/* Global Alert Modal */}
            <ModalShell
                isOpen={dialogs.alert?.isOpen || false}
                title={
                    <span className="flex items-center gap-2 text-white">
                        <span className="material-symbols-outlined text-indigo-400 text-[18px]">info</span>
                        {dialogs.alert?.title || 'Notice'}
                    </span>
                }
                onClose={() => {
                    if (dialogs.alert?.onClose) dialogs.alert.onClose();
                }}
                maxWidth="max-w-md"
            >
                <div className="p-6 space-y-4">
                    <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-wrap">
                        {dialogs.alert?.message}
                    </p>
                    <div className="flex justify-end pt-3 border-t border-slate-800">
                        <button
                            type="button"
                            onClick={() => {
                                if (dialogs.alert?.onClose) dialogs.alert.onClose();
                            }}
                            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg text-xs font-bold transition-colors shadow-sm"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </ModalShell>

            {/* Global Confirm Modal */}
            <ModalShell
                isOpen={dialogs.confirm?.isOpen || false}
                title={
                    <span className="flex items-center gap-2 text-white">
                        <span className="material-symbols-outlined text-rose-500 text-[20px]">warning</span>
                        {dialogs.confirm?.title || 'Confirm Deletion'}
                    </span>
                }
                onClose={() => {
                    if (dialogs.confirm?.onCancel) dialogs.confirm.onCancel();
                }}
                maxWidth="max-w-md"
            >
                <div className="p-6 space-y-4">
                    <div className="flex items-start gap-3">
                        <div className="p-2 rounded-xl bg-rose-950/60 border border-rose-900/60 shrink-0 text-rose-400">
                            <span className="material-symbols-outlined text-[24px]">delete_forever</span>
                        </div>
                        <p className="text-sm text-slate-200 leading-relaxed whitespace-pre-wrap pt-0.5">
                            {dialogs.confirm?.message}
                        </p>
                    </div>
                    <div className="flex justify-end gap-3 pt-3 border-t border-slate-800">
                        <button
                            type="button"
                            onClick={() => {
                                if (dialogs.confirm?.onCancel) dialogs.confirm.onCancel();
                            }}
                            className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white rounded-lg text-xs font-bold transition-colors border border-slate-700"
                        >
                            {dialogs.confirm?.cancelText || 'Cancel'}
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                if (dialogs.confirm?.onConfirm) dialogs.confirm.onConfirm();
                            }}
                            className="px-4 py-2 bg-rose-600 hover:bg-rose-500 text-white rounded-lg text-xs font-bold transition-colors flex items-center gap-1.5 shadow-md shadow-rose-950/50"
                        >
                            <span className="material-symbols-outlined text-[14px]">delete</span>
                            {dialogs.confirm?.confirmText || 'Delete Permanently'}
                        </button>
                    </div>
                </div>
            </ModalShell>
        </>
    );
}
